import _defineProperty2 from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { forEach, isArray, reduce, isEmpty } from 'lodash';
import { TOKKEN, dataMapping } from './constants';
export var fetchData = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(url, params, _ref) {
    var _ref$apiKey, apiKey, _ref$sessionId, sessionId, _ref$isTokkenValue, isTokkenValue, _ref$userTokken, userTokken, _ref$keepalive, keepalive, _ref$isGetRequest, isGetRequest, headers, requestOptions, response, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref$apiKey = _ref.apiKey, apiKey = _ref$apiKey === void 0 ? '' : _ref$apiKey, _ref$sessionId = _ref.sessionId, sessionId = _ref$sessionId === void 0 ? '' : _ref$sessionId, _ref$isTokkenValue = _ref.isTokkenValue, isTokkenValue = _ref$isTokkenValue === void 0 ? false : _ref$isTokkenValue, _ref$userTokken = _ref.userTokken, userTokken = _ref$userTokken === void 0 ? null : _ref$userTokken, _ref$keepalive = _ref.keepalive, keepalive = _ref$keepalive === void 0 ? true : _ref$keepalive, _ref$isGetRequest = _ref.isGetRequest, isGetRequest = _ref$isGetRequest === void 0 ? false : _ref$isGetRequest;
          headers = new Headers();
          headers.append('X-Request-Id', sessionId);
          headers.append('Apikey', apiKey);
          isTokkenValue && headers.append('Authorization', userTokken || TOKKEN);
          isGetRequest ? headers.append('Content-Type', 'none') : headers.append('Content-Type', 'application/json');
          headers.append('Accept', 'application/json');
          headers.append('Access-Control-Max-Age', '6000');
          headers.append('Access-Control-Allow-Origin', '*');
          headers.append('Host', 'dacqa.detsandbox.com');
          headers.append('User-Agent', 'Apidog/1.0.0 (https://apidog.com)');
          requestOptions = _objectSpread(_objectSpread({}, params), {}, {
            headers: headers,
            keepalive: keepalive,
            withCredentials: true
          });
          _context.prev = 12;
          _context.next = 15;
          return fetch(url, requestOptions);
        case 15:
          response = _context.sent;
          _context.prev = 16;
          _context.next = 19;
          return response.json();
        case 19:
          data = _context.sent;
          if (!isArray(data)) {
            _context.next = 22;
            break;
          }
          return _context.abrupt("return", data);
        case 22:
          return _context.abrupt("return", _objectSpread(_objectSpread({}, data), {}, {
            status: response.status
          }));
        case 25:
          _context.prev = 25;
          _context.t0 = _context["catch"](16);
          return _context.abrupt("return", {
            status: response.status
          });
        case 28:
          _context.next = 33;
          break;
        case 30:
          _context.prev = 30;
          _context.t1 = _context["catch"](12);
          return _context.abrupt("return", {});
        case 33:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[12, 30], [16, 25]]);
  }));
  return function fetchData(_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
export var SaveLongTourismEntryPermit = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref3, context, isDraft) {
    var _ref3$apiUrl,
      apiUrl,
      _ref3$apiKey,
      apiKey,
      _ref3$sessionId,
      sessionId,
      _ref3$userTokken,
      userTokken,
      history,
      redirectUrl,
      username,
      _ref3$serviceId,
      serviceId,
      applicationNumber,
      appid,
      staticData,
      data,
      requestOptions,
      url,
      result,
      status,
      _result$data,
      resultData,
      _result$desc,
      desc,
      _args2 = arguments;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _ref3$apiUrl = _ref3.apiUrl, apiUrl = _ref3$apiUrl === void 0 ? '' : _ref3$apiUrl, _ref3$apiKey = _ref3.apiKey, apiKey = _ref3$apiKey === void 0 ? '' : _ref3$apiKey, _ref3$sessionId = _ref3.sessionId, sessionId = _ref3$sessionId === void 0 ? '' : _ref3$sessionId, _ref3$userTokken = _ref3.userTokken, userTokken = _ref3$userTokken === void 0 ? null : _ref3$userTokken, history = _ref3.history, redirectUrl = _ref3.redirectUrl, username = _ref3.username, _ref3$serviceId = _ref3.serviceId, serviceId = _ref3$serviceId === void 0 ? 'a2959b4f-bd7c-4243-8c7a-eab53903f6b4' : _ref3$serviceId;
          applicationNumber = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : '';
          appid = applicationNumber.length ? {
            applicationNumber: applicationNumber
          } : {};
          staticData = {
            emailConsent: true,
            username: username,
            applicationInfo: _objectSpread({
              isDraft: isDraft
            }, appid)
          };
          data = reduce(dataMapping, function (acc, fields, fieldName) {
            if (isArray(fields) && fieldName) {
              var currentFieldGroup = acc[fieldName];
              forEach(fields, function (name) {
                var value = context[name] && context[name].value || '';
                if (context[name] && context[name].code && !value.startsWith('0')) value = context[name].code + value;
                var fieldData = context[name] && context[name].value && _defineProperty2({}, name, value) || {};
                currentFieldGroup = _objectSpread(_objectSpread({}, currentFieldGroup), fieldData);
              });
              acc = _objectSpread(_objectSpread({}, acc), _defineProperty2({}, fieldName, currentFieldGroup));
              return acc;
            }
            return acc;
          }, {});
          data.applicantDetails.birthCountryId = context['currentNationalityId'] && context['currentNationalityId'].value;
          data.passportDetails.passportIssueGovId = context['passportIssueCountryId'] && context['passportIssueCountryId'].value;
          data.contactInfo.preferredSmsLanguage = '2';
          data.visitDetails.entryType = 2;
          data.contactInfo.mobileNo = '971500000000';
          requestOptions = {
            method: 'POST',
            redirect: 'follow',
            body: JSON.stringify(_objectSpread(_objectSpread({}, staticData), data))
          };
          url = "".concat(apiUrl, "/v1/orc/application/").concat(serviceId);
          _context2.next = 14;
          return fetchData(url, requestOptions, {
            apiKey: apiKey,
            sessionId: sessionId,
            isTokkenValue: true,
            userTokken: userTokken
          });
        case 14:
          result = _context2.sent;
          status = result.status, _result$data = result.data, resultData = _result$data === void 0 ? {} : _result$data, _result$desc = result.desc, desc = _result$desc === void 0 ? {} : _result$desc;
          if (status === 401) {
            history.push(redirectUrl);
          }
          return _context2.abrupt("return", _objectSpread(_objectSpread({}, resultData), {}, {
            error: desc
          }));
        case 18:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function SaveLongTourismEntryPermit(_x4, _x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();
export var Translate = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref6) {
    var _ref6$apiUrl,
      apiUrl,
      _ref6$apiKey,
      apiKey,
      _ref6$sessionId,
      sessionId,
      _ref6$userTokken,
      userTokken,
      history,
      redirectUrl,
      text,
      data,
      url,
      requestOptions,
      result,
      status,
      TranslatedText,
      _args3 = arguments;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _ref6$apiUrl = _ref6.apiUrl, apiUrl = _ref6$apiUrl === void 0 ? '' : _ref6$apiUrl, _ref6$apiKey = _ref6.apiKey, apiKey = _ref6$apiKey === void 0 ? '' : _ref6$apiKey, _ref6$sessionId = _ref6.sessionId, sessionId = _ref6$sessionId === void 0 ? '' : _ref6$sessionId, _ref6$userTokken = _ref6.userTokken, userTokken = _ref6$userTokken === void 0 ? null : _ref6$userTokken, history = _ref6.history, redirectUrl = _ref6.redirectUrl;
          text = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : '';
          data = {
            TextToTranslate: text,
            IsEnglishToArabic: true
          };
          url = "".concat(apiUrl, "/v1/proxy/translate");
          requestOptions = {
            method: 'POST',
            body: JSON.stringify(data),
            redirect: 'follow'
          };
          _context3.next = 7;
          return fetchData(url, requestOptions, {
            apiKey: apiKey,
            sessionId: sessionId,
            isTokkenValue: true,
            userTokken: userTokken
          });
        case 7:
          result = _context3.sent;
          status = result.status, TranslatedText = result.TranslatedText;
          if (status === 401) {
            history.push(redirectUrl);
          }
          if (!(status === 500)) {
            _context3.next = 12;
            break;
          }
          return _context3.abrupt("return", text);
        case 12:
          return _context3.abrupt("return", TranslatedText || text);
        case 13:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function Translate(_x7) {
    return _ref7.apply(this, arguments);
  };
}();
export var GetDetails = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_ref8, applicationNumber) {
    var _ref8$apiUrl, apiUrl, _ref8$apiKey, apiKey, _ref8$sessionId, sessionId, _ref8$userTokken, userTokken, history, redirectUrl, url, requestOptions, result, status, _result$applicationRe, applicationRequest, data;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _ref8$apiUrl = _ref8.apiUrl, apiUrl = _ref8$apiUrl === void 0 ? '' : _ref8$apiUrl, _ref8$apiKey = _ref8.apiKey, apiKey = _ref8$apiKey === void 0 ? '' : _ref8$apiKey, _ref8$sessionId = _ref8.sessionId, sessionId = _ref8$sessionId === void 0 ? '' : _ref8$sessionId, _ref8$userTokken = _ref8.userTokken, userTokken = _ref8$userTokken === void 0 ? null : _ref8$userTokken, history = _ref8.history, redirectUrl = _ref8.redirectUrl;
          url = "".concat(apiUrl, "/v1/proxy/details/").concat(applicationNumber);
          requestOptions = {
            method: 'GET',
            redirect: 'follow'
          };
          _context4.next = 5;
          return fetchData(url, requestOptions, {
            apiKey: apiKey,
            sessionId: sessionId,
            isTokkenValue: true,
            userTokken: userTokken
          });
        case 5:
          result = _context4.sent;
          status = result.status, _result$applicationRe = result.applicationRequest, applicationRequest = _result$applicationRe === void 0 ? {} : _result$applicationRe;
          if (status === 401) {
            history.push(redirectUrl);
          }
          data = reduce(applicationRequest, function (acc, fields) {
            forEach(fields, function (value, name) {
              acc = _objectSpread(_objectSpread({}, acc), _defineProperty2({}, name, value));
            });
            return acc;
          }, {});
          if (data.sponsorEmail) data.ConfirmEmail = data.sponsorEmail;
          if (data.sponsorEmail) data.email = data.sponsorEmail;
          if (data.faithId) data.FaithId = data.faithId;

          // if (data.mobileNo) {
          //   const parsedmobileNo = parsePhoneNumber(data.mobileNo);

          //   if (parsedmobileNo) data.mobileNo = parsedmobileNo.nationalNumber;
          // }

          // if (data.addressOutsideTelNo) {
          //   const parsedmobileNo = parsePhoneNumber(`+${data.addressOutsideTelNo}`);

          //   if (parsedmobileNo) data.addressOutsideTelNo = parsedmobileNo.nationalNumber;
          // }
          return _context4.abrupt("return", data);
        case 13:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function GetDetails(_x8, _x9) {
    return _ref9.apply(this, arguments);
  };
}();
export var Notify = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_ref10, context) {
    var _ref10$apiUrl, apiUrl, _ref10$apiKey, apiKey, _ref10$sessionId, sessionId, _ref10$userTokken, userTokken, _ref10$username, username, data, url, requestOptions, result, status, Success;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _ref10$apiUrl = _ref10.apiUrl, apiUrl = _ref10$apiUrl === void 0 ? '' : _ref10$apiUrl, _ref10$apiKey = _ref10.apiKey, apiKey = _ref10$apiKey === void 0 ? '' : _ref10$apiKey, _ref10$sessionId = _ref10.sessionId, sessionId = _ref10$sessionId === void 0 ? '' : _ref10$sessionId, _ref10$userTokken = _ref10.userTokken, userTokken = _ref10$userTokken === void 0 ? null : _ref10$userTokken, _ref10$username = _ref10.username, username = _ref10$username === void 0 ? '' : _ref10$username;
          data = {
            email: context['notifyEmail'].value,
            firstNameEN: context['firstNameEN'].value,
            middleNameEN: context['middleNameEN'].value,
            lastNameEN: context['lastNameEN'].value,
            nationality: context['currentNationalityId'].value,
            passportIssueGov: context['passportIssueCountryId'].value,
            birthDate: context['birthDate'].value,
            mobileNo: '',
            username: username
          };
          url = "".concat(apiUrl, "/v1/orc/notify");
          requestOptions = {
            method: 'POST',
            body: JSON.stringify(data),
            redirect: 'follow'
          };
          _context5.next = 6;
          return fetchData(url, requestOptions, {
            apiKey: apiKey,
            sessionId: sessionId,
            isTokkenValue: true,
            userTokken: userTokken
          });
        case 6:
          result = _context5.sent;
          status = result.status, Success = result.Success;
          if (!(status !== 200)) {
            _context5.next = 10;
            break;
          }
          return _context5.abrupt("return", false);
        case 10:
          return _context5.abrupt("return", Success);
        case 11:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function Notify(_x10, _x11) {
    return _ref11.apply(this, arguments);
  };
}();
export var IdndividualProfileInquiry = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(_ref12, context) {
    var _ref12$apiUrl, apiUrl, _ref12$apiKey, apiKey, _ref12$sessionId, sessionId, _ref12$userTokken, userTokken, history, redirectUrl, yearOfBirth, data, url, requestOptions, result, _result$status, status, profileInquiryConsolidated, contactInfo, passportDetails, personInfo, prsNationality;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _ref12$apiUrl = _ref12.apiUrl, apiUrl = _ref12$apiUrl === void 0 ? '' : _ref12$apiUrl, _ref12$apiKey = _ref12.apiKey, apiKey = _ref12$apiKey === void 0 ? '' : _ref12$apiKey, _ref12$sessionId = _ref12.sessionId, sessionId = _ref12$sessionId === void 0 ? '' : _ref12$sessionId, _ref12$userTokken = _ref12.userTokken, userTokken = _ref12$userTokken === void 0 ? null : _ref12$userTokken, history = _ref12.history, redirectUrl = _ref12.redirectUrl;
          yearOfBirth = new Date(context['birthDate'].value.replaceAll('-', '/') || '');
          data = {
            passportNo: context['passportNo'].value,
            nationalityId: context['currentNationalityId'].value,
            yearOfBirth: yearOfBirth.getFullYear(),
            fileType: context['passportTypeId'].value,
            fileNo: ''
          };
          url = "".concat(apiUrl, "/v1/orc/resource/inquiry/individual/profile");
          requestOptions = {
            method: 'POST',
            body: JSON.stringify(data),
            redirect: 'follow'
          };
          _context6.next = 7;
          return fetchData(url, requestOptions, {
            apiKey: apiKey,
            sessionId: sessionId,
            isTokkenValue: true,
            userTokken: userTokken
          });
        case 7:
          result = _context6.sent;
          _result$status = result.status, status = _result$status === void 0 ? 500 : _result$status, profileInquiryConsolidated = result.profileInquiryConsolidated;
          if (status === 401) {
            history.push(redirectUrl);
          }
          if (!(status !== 200 || !profileInquiryConsolidated)) {
            _context6.next = 12;
            break;
          }
          return _context6.abrupt("return", {
            status: status
          });
        case 12:
          contactInfo = profileInquiryConsolidated.contactInfo, passportDetails = profileInquiryConsolidated.passportDetails, personInfo = profileInquiryConsolidated.personInfo, prsNationality = profileInquiryConsolidated.prsNationality;
          return _context6.abrupt("return", {
            data: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, contactInfo), passportDetails), personInfo), {}, {
              prsNationality: prsNationality
            }),
            status: status
          });
        case 14:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function IdndividualProfileInquiry(_x12, _x13) {
    return _ref13.apply(this, arguments);
  };
}();
export var GetAllLookups = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(_ref14) {
    var _ref14$apiUrl, apiUrl, _ref14$apiKey, apiKey, _ref14$sessionId, sessionId, _ref14$userTokken, userTokken, history, url, requestOptions, result, _result$status2, status;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _ref14$apiUrl = _ref14.apiUrl, apiUrl = _ref14$apiUrl === void 0 ? '' : _ref14$apiUrl, _ref14$apiKey = _ref14.apiKey, apiKey = _ref14$apiKey === void 0 ? '' : _ref14$apiKey, _ref14$sessionId = _ref14.sessionId, sessionId = _ref14$sessionId === void 0 ? '' : _ref14$sessionId, _ref14$userTokken = _ref14.userTokken, userTokken = _ref14$userTokken === void 0 ? null : _ref14$userTokken, history = _ref14.history;
          url = "".concat(apiUrl, "/v1/orc/lookups");
          requestOptions = {
            method: 'GET'
          };
          _context7.next = 5;
          return fetchData(url, requestOptions, {
            apiKey: apiKey,
            sessionId: sessionId,
            userTokken: userTokken
          });
        case 5:
          result = _context7.sent;
          _result$status2 = result.status, status = _result$status2 === void 0 ? 200 : _result$status2;
          if (!(status !== 200)) {
            _context7.next = 9;
            break;
          }
          return _context7.abrupt("return", []);
        case 9:
          return _context7.abrupt("return", result && result[0] && result[0].lookupData || []);
        case 10:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function GetAllLookups(_x14) {
    return _ref15.apply(this, arguments);
  };
}();
export var GetLookupById = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(_ref16) {
    var _ref16$apiUrl, apiUrl, _ref16$apiKey, apiKey, _ref16$sessionId, sessionId, _ref16$userTokken, userTokken, _ref16$lookupid, lookupid, url, requestOptions, result, _result$status3, status;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _ref16$apiUrl = _ref16.apiUrl, apiUrl = _ref16$apiUrl === void 0 ? '' : _ref16$apiUrl, _ref16$apiKey = _ref16.apiKey, apiKey = _ref16$apiKey === void 0 ? '' : _ref16$apiKey, _ref16$sessionId = _ref16.sessionId, sessionId = _ref16$sessionId === void 0 ? '' : _ref16$sessionId, _ref16$userTokken = _ref16.userTokken, userTokken = _ref16$userTokken === void 0 ? null : _ref16$userTokken, _ref16$lookupid = _ref16.lookupid, lookupid = _ref16$lookupid === void 0 ? '' : _ref16$lookupid;
          url = "".concat(apiUrl, "/v1/proxy/lookup/").concat(lookupid, "/items");
          requestOptions = {
            method: 'GET'
          };
          _context8.next = 5;
          return fetchData(url, requestOptions, {
            apiKey: apiKey,
            sessionId: sessionId,
            userTokken: userTokken
          });
        case 5:
          result = _context8.sent;
          _result$status3 = result.status, status = _result$status3 === void 0 ? 200 : _result$status3;
          if (!(status !== 200 || isEmpty(result))) {
            _context8.next = 9;
            break;
          }
          return _context8.abrupt("return", []);
        case 9:
          return _context8.abrupt("return", result || []);
        case 10:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function GetLookupById(_x15) {
    return _ref17.apply(this, arguments);
  };
}();
export var GetPaymentURL = /*#__PURE__*/function () {
  var _ref19 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(_ref18, applicationNumber) {
    var _ref18$apiUrl, apiUrl, _ref18$apiKey, apiKey, _ref18$sessionId, sessionId, _ref18$userTokken, userTokken, history, redirectUrl, url, requestOptions, result, status, NoqodiPaymentURL, desc;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _ref18$apiUrl = _ref18.apiUrl, apiUrl = _ref18$apiUrl === void 0 ? '' : _ref18$apiUrl, _ref18$apiKey = _ref18.apiKey, apiKey = _ref18$apiKey === void 0 ? '' : _ref18$apiKey, _ref18$sessionId = _ref18.sessionId, sessionId = _ref18$sessionId === void 0 ? '' : _ref18$sessionId, _ref18$userTokken = _ref18.userTokken, userTokken = _ref18$userTokken === void 0 ? null : _ref18$userTokken, history = _ref18.history, redirectUrl = _ref18.redirectUrl;
          url = "".concat(apiUrl, "/v1/orc/payment/").concat(applicationNumber, "/url?isEmbeded=true");
          requestOptions = {
            method: 'GET'
          };
          _context9.next = 5;
          return fetchData(url, requestOptions, {
            apiKey: apiKey,
            sessionId: sessionId,
            isTokkenValue: true,
            userTokken: userTokken,
            isGetRequest: true
          });
        case 5:
          result = _context9.sent;
          status = result.status, NoqodiPaymentURL = result.NoqodiPaymentURL, desc = result.desc;
          if (status === 401) {
            history.push(redirectUrl);
          }
          return _context9.abrupt("return", {
            paymentUrl: NoqodiPaymentURL,
            error: desc
          });
        case 9:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return function GetPaymentURL(_x16, _x17) {
    return _ref19.apply(this, arguments);
  };
}();
export var GetFees = /*#__PURE__*/function () {
  var _ref21 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(_ref20, applicationId) {
    var _ref20$apiUrl,
      apiUrl,
      _ref20$apiKey,
      apiKey,
      _ref20$sessionId,
      sessionId,
      _ref20$userTokken,
      userTokken,
      _ref20$redirectUrl,
      redirectUrl,
      history,
      dashboardUrl,
      validate,
      url,
      data,
      requestOptions,
      result,
      status,
      _result$fees,
      feesList,
      _result$desc2,
      error,
      _args10 = arguments;
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _ref20$apiUrl = _ref20.apiUrl, apiUrl = _ref20$apiUrl === void 0 ? '' : _ref20$apiUrl, _ref20$apiKey = _ref20.apiKey, apiKey = _ref20$apiKey === void 0 ? '' : _ref20$apiKey, _ref20$sessionId = _ref20.sessionId, sessionId = _ref20$sessionId === void 0 ? '' : _ref20$sessionId, _ref20$userTokken = _ref20.userTokken, userTokken = _ref20$userTokken === void 0 ? null : _ref20$userTokken, _ref20$redirectUrl = _ref20.redirectUrl, redirectUrl = _ref20$redirectUrl === void 0 ? '' : _ref20$redirectUrl, history = _ref20.history, dashboardUrl = _ref20.dashboardUrl;
          validate = _args10.length > 2 && _args10[2] !== undefined ? _args10[2] : true;
          url = "".concat(apiUrl, "/v1/proxy/application/fees");
          data = {
            applicationId: applicationId,
            validate: validate
          };
          requestOptions = {
            method: 'POST',
            redirect: 'follow',
            body: JSON.stringify(data)
          };
          _context10.next = 7;
          return fetchData(url, requestOptions, {
            apiKey: apiKey,
            sessionId: sessionId,
            isTokkenValue: true,
            userTokken: userTokken
          });
        case 7:
          result = _context10.sent;
          status = result.status, _result$fees = result.fees, feesList = _result$fees === void 0 ? [] : _result$fees, _result$desc2 = result.desc, error = _result$desc2 === void 0 ? {} : _result$desc2;
          if (status === 401) {
            history.push(redirectUrl);
          }
          return _context10.abrupt("return", {
            feesList: feesList,
            error: error
          });
        case 11:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return function GetFees(_x18, _x19) {
    return _ref21.apply(this, arguments);
  };
}();
export var Search = /*#__PURE__*/function () {
  var _ref23 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11(_ref22, ApplicationNo) {
    var _ref22$apiUrl, apiUrl, _ref22$apiKey, apiKey, _ref22$sessionId, sessionId, _ref22$userTokken, userTokken, _ref22$redirectUrl, redirectUrl, history, dashboardUrl, url, data, requestOptions, result, status, _result$ApplicationLi, ApplicationList, _result$desc3, error, applicationData;
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _ref22$apiUrl = _ref22.apiUrl, apiUrl = _ref22$apiUrl === void 0 ? '' : _ref22$apiUrl, _ref22$apiKey = _ref22.apiKey, apiKey = _ref22$apiKey === void 0 ? '' : _ref22$apiKey, _ref22$sessionId = _ref22.sessionId, sessionId = _ref22$sessionId === void 0 ? '' : _ref22$sessionId, _ref22$userTokken = _ref22.userTokken, userTokken = _ref22$userTokken === void 0 ? null : _ref22$userTokken, _ref22$redirectUrl = _ref22.redirectUrl, redirectUrl = _ref22$redirectUrl === void 0 ? '' : _ref22$redirectUrl, history = _ref22.history, dashboardUrl = _ref22.dashboardUrl;
          url = "".concat(apiUrl, "/v1/proxy/inquiry/individual/application/search");
          data = {
            ApplicationNo: ApplicationNo,
            pageNumber: 1,
            pageSize: 10,
            statusIds: '',
            includeService: '',
            excludeService: ''
          };
          requestOptions = {
            method: 'POST',
            redirect: 'follow',
            body: JSON.stringify(data)
          };
          _context11.next = 6;
          return fetchData(url, requestOptions, {
            apiKey: apiKey,
            sessionId: sessionId,
            isTokkenValue: true,
            userTokken: userTokken
          });
        case 6:
          result = _context11.sent;
          status = result.status, _result$ApplicationLi = result.ApplicationList, ApplicationList = _result$ApplicationLi === void 0 ? [] : _result$ApplicationLi, _result$desc3 = result.desc, error = _result$desc3 === void 0 ? {} : _result$desc3;
          applicationData = ApplicationList[0];
          if (status === 401) {
            history.push(redirectUrl);
          }
          return _context11.abrupt("return", {
            applicationData: applicationData,
            error: error
          });
        case 11:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return function Search(_x20, _x21) {
    return _ref23.apply(this, arguments);
  };
}();
export var ApplicationStatus = /*#__PURE__*/function () {
  var _ref25 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(_ref24, applicationId) {
    var _ref24$apiUrl,
      apiUrl,
      _ref24$apiKey,
      apiKey,
      _ref24$sessionId,
      sessionId,
      _ref24$userTokken,
      userTokken,
      _ref24$redirectUrl,
      redirectUrl,
      history,
      validate,
      url,
      requestOptions,
      result,
      status,
      fees,
      _args12 = arguments;
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _ref24$apiUrl = _ref24.apiUrl, apiUrl = _ref24$apiUrl === void 0 ? '' : _ref24$apiUrl, _ref24$apiKey = _ref24.apiKey, apiKey = _ref24$apiKey === void 0 ? '' : _ref24$apiKey, _ref24$sessionId = _ref24.sessionId, sessionId = _ref24$sessionId === void 0 ? '' : _ref24$sessionId, _ref24$userTokken = _ref24.userTokken, userTokken = _ref24$userTokken === void 0 ? null : _ref24$userTokken, _ref24$redirectUrl = _ref24.redirectUrl, redirectUrl = _ref24$redirectUrl === void 0 ? '' : _ref24$redirectUrl, history = _ref24.history;
          validate = _args12.length > 2 && _args12[2] !== undefined ? _args12[2] : true;
          url = "".concat(apiUrl, "//v1/proxy/resource/inquiry/application/").concat(applicationId, "/status");
          requestOptions = {
            method: 'GET',
            redirect: 'follow'
          };
          _context12.next = 6;
          return fetchData(url, requestOptions, {
            apiKey: apiKey,
            sessionId: sessionId,
            isTokkenValue: true,
            userTokken: userTokken
          });
        case 6:
          result = _context12.sent;
          status = result.status, fees = result.fees;
          if (status === 401) {
            history.push(redirectUrl);
          }
          return _context12.abrupt("return", fees || []);
        case 10:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return function ApplicationStatus(_x22, _x23) {
    return _ref25.apply(this, arguments);
  };
}();
export var getDocumentsData = /*#__PURE__*/function () {
  var _ref27 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13(_ref26, applicationNumber) {
    var _ref26$apiUrl, apiUrl, _ref26$apiKey, apiKey, _ref26$sessionId, sessionId, _ref26$userTokken, userTokken, url, requestOptions, result;
    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _ref26$apiUrl = _ref26.apiUrl, apiUrl = _ref26$apiUrl === void 0 ? '' : _ref26$apiUrl, _ref26$apiKey = _ref26.apiKey, apiKey = _ref26$apiKey === void 0 ? '' : _ref26$apiKey, _ref26$sessionId = _ref26.sessionId, sessionId = _ref26$sessionId === void 0 ? '' : _ref26$sessionId, _ref26$userTokken = _ref26.userTokken, userTokken = _ref26$userTokken === void 0 ? null : _ref26$userTokken;
          url = "".concat(apiUrl, "/v1/proxy/application/").concat(applicationNumber, "/documents");
          requestOptions = {
            method: 'GET'
          };
          _context13.next = 5;
          return fetchData(url, requestOptions, {
            apiKey: apiKey,
            sessionId: sessionId,
            isTokkenValue: true,
            userTokken: userTokken
          });
        case 5:
          result = _context13.sent;
          return _context13.abrupt("return", result);
        case 7:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return function getDocumentsData(_x24, _x25) {
    return _ref27.apply(this, arguments);
  };
}();
export var UploadDocument = /*#__PURE__*/function () {
  var _ref29 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14(_ref28, applicationId, documentsObject, onProgress) {
    var _ref28$apiUrl, apiUrl, _ref28$apiKey, apiKey, _ref28$userTokken, userTokken, _ref28$sessionId, sessionId, data, url, xhr;
    return _regeneratorRuntime().wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _ref28$apiUrl = _ref28.apiUrl, apiUrl = _ref28$apiUrl === void 0 ? '' : _ref28$apiUrl, _ref28$apiKey = _ref28.apiKey, apiKey = _ref28$apiKey === void 0 ? '' : _ref28$apiKey, _ref28$userTokken = _ref28.userTokken, userTokken = _ref28$userTokken === void 0 ? null : _ref28$userTokken, _ref28$sessionId = _ref28.sessionId, sessionId = _ref28$sessionId === void 0 ? '' : _ref28$sessionId;
          data = {
            Documents: documentsObject,
            applicationId: applicationId
          };
          url = "".concat(apiUrl, "/v1/orc/application/documents/upload");
          xhr = new XMLHttpRequest();
          _context14.next = 6;
          return new Promise(function (resolve, reject) {
            xhr.upload.addEventListener('progress', function (event) {
              if (event.lengthComputable) {
                onProgress(Math.round(event.loaded / event.total * 100));
              }
            });
            xhr.addEventListener('readystatechange', function () {
              if (xhr.readyState === XMLHttpRequest.DONE) {
                try {
                  resolve(JSON.parse(xhr.responseText));
                } catch (err) {
                  reject(err);
                }
              }
            });
            xhr.open('POST', url, true);
            xhr.setRequestHeader('X-Request-Id', sessionId);
            xhr.setRequestHeader('Apikey', apiKey);
            xhr.setRequestHeader('Authorization', userTokken || TOKKEN);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.setRequestHeader('Accept', 'application/json');
            xhr.setRequestHeader('Host', 'dacqa.detsandbox.com');
            xhr.setRequestHeader('User-Agent', 'Apidog/1.0.0 (https://apidog.com)');
            xhr.send(JSON.stringify(data));
          });
        case 6:
          return _context14.abrupt("return", _context14.sent);
        case 7:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return function UploadDocument(_x26, _x27, _x28, _x29) {
    return _ref29.apply(this, arguments);
  };
}();
export var PaymentValidation = /*#__PURE__*/function () {
  var _ref31 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15(_ref30, data) {
    var _ref30$apiUrl, apiUrl, _ref30$apiKey, apiKey, _ref30$userTokken, userTokken, _ref30$sessionId, sessionId, url, requestOptions, _yield$fetchData, Success, _yield$fetchData$desc, error, status;
    return _regeneratorRuntime().wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          _ref30$apiUrl = _ref30.apiUrl, apiUrl = _ref30$apiUrl === void 0 ? '' : _ref30$apiUrl, _ref30$apiKey = _ref30.apiKey, apiKey = _ref30$apiKey === void 0 ? '' : _ref30$apiKey, _ref30$userTokken = _ref30.userTokken, userTokken = _ref30$userTokken === void 0 ? null : _ref30$userTokken, _ref30$sessionId = _ref30.sessionId, sessionId = _ref30$sessionId === void 0 ? '' : _ref30$sessionId;
          url = "".concat(apiUrl, "/v1/orc/payment/complete");
          requestOptions = {
            method: 'POST',
            body: JSON.stringify(data)
          };
          _context15.next = 5;
          return fetchData(url, requestOptions, {
            apiKey: apiKey,
            sessionId: sessionId,
            userTokken: userTokken,
            isTokkenValue: true
          });
        case 5:
          _yield$fetchData = _context15.sent;
          Success = _yield$fetchData.Success;
          _yield$fetchData$desc = _yield$fetchData.desc;
          error = _yield$fetchData$desc === void 0 ? {} : _yield$fetchData$desc;
          status = _yield$fetchData.status;
          if (!(status === 200)) {
            _context15.next = 12;
            break;
          }
          return _context15.abrupt("return", {
            Success: true,
            error: error
          });
        case 12:
          return _context15.abrupt("return", {
            Success: Success,
            error: error
          });
        case 13:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return function PaymentValidation(_x30, _x31) {
    return _ref31.apply(this, arguments);
  };
}();
export var GetInvitationCodes = /*#__PURE__*/function () {
  var _ref33 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16(_ref32, data) {
    var _ref32$apiUrl, apiUrl, _ref32$apiKey, apiKey, _ref32$userTokken, userTokken, _ref32$sessionId, sessionId, url, requestOptions, _yield$fetchData2, Success, _yield$fetchData2$des, error;
    return _regeneratorRuntime().wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          _ref32$apiUrl = _ref32.apiUrl, apiUrl = _ref32$apiUrl === void 0 ? '' : _ref32$apiUrl, _ref32$apiKey = _ref32.apiKey, apiKey = _ref32$apiKey === void 0 ? '' : _ref32$apiKey, _ref32$userTokken = _ref32.userTokken, userTokken = _ref32$userTokken === void 0 ? null : _ref32$userTokken, _ref32$sessionId = _ref32.sessionId, sessionId = _ref32$sessionId === void 0 ? '' : _ref32$sessionId;
          url = "".concat(apiUrl, "/v1/orc/invitationcodes");
          requestOptions = {
            method: 'POST',
            body: JSON.stringify(data)
          };
          _context16.next = 5;
          return fetchData(url, requestOptions, {
            apiKey: apiKey,
            sessionId: sessionId,
            userTokken: userTokken
          });
        case 5:
          _yield$fetchData2 = _context16.sent;
          Success = _yield$fetchData2.Success;
          _yield$fetchData2$des = _yield$fetchData2.desc;
          error = _yield$fetchData2$des === void 0 ? {} : _yield$fetchData2$des;
          return _context16.abrupt("return", {
            Success: Success,
            error: error
          });
        case 10:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return function GetInvitationCodes(_x32, _x33) {
    return _ref33.apply(this, arguments);
  };
}();
export var uploadConsent = /*#__PURE__*/function () {
  var _ref35 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17(_ref34, sendData) {
    var _ref34$apiKey, apiKey, _ref34$sessionId, sessionId, url, headers, data, requestOptions, response, _data;
    return _regeneratorRuntime().wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          _ref34$apiKey = _ref34.apiKey, apiKey = _ref34$apiKey === void 0 ? '' : _ref34$apiKey, _ref34$sessionId = _ref34.sessionId, sessionId = _ref34$sessionId === void 0 ? '' : _ref34$sessionId;
          url = 'https://app5.securiti.ai/privaci/v1/consentapi/consent_upload';
          headers = new Headers();
          headers.append('X-Request-Id', sessionId);
          headers.append('Content-Type', 'application/json');
          headers.append('Host', 'app.eu.securiti.ai');
          headers.append('X-API-Key', '8s0xdf9DmCBT6vFLOCbtSwB3GZ5Cxq46k5zgXrB8');
          headers.append('X-API-Secret', 'tjVkG6z3fSbBuKb24P8HM5qc3LzOgYviICqsC772');
          headers.append('X-TIDENT', '0f26a629-0c1e-4d0f-a04b-add9ce0aaeec');
          data = _objectSpread({}, sendData);
          requestOptions = {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(data)
          };
          _context17.prev = 11;
          _context17.next = 14;
          return fetch(url, requestOptions);
        case 14:
          response = _context17.sent;
          _context17.prev = 15;
          _context17.next = 18;
          return response.json();
        case 18:
          _data = _context17.sent;
          if (!isArray(_data)) {
            _context17.next = 21;
            break;
          }
          return _context17.abrupt("return", _data);
        case 21:
          return _context17.abrupt("return", _objectSpread(_objectSpread({}, _data), {}, {
            status: response.status
          }));
        case 24:
          _context17.prev = 24;
          _context17.t0 = _context17["catch"](15);
          return _context17.abrupt("return", {
            status: response.status
          });
        case 27:
          _context17.next = 32;
          break;
        case 29:
          _context17.prev = 29;
          _context17.t1 = _context17["catch"](11);
          return _context17.abrupt("return", {});
        case 32:
        case "end":
          return _context17.stop();
      }
    }, _callee17, null, [[11, 29], [15, 24]]);
  }));
  return function uploadConsent(_x34, _x35) {
    return _ref35.apply(this, arguments);
  };
}();